export default "__VITE_ASSET__DQrllENJ__"